module.exports = __webpack_public_path__ + "media/images/Logo-dbf821b72f7747cdaf2679e006c16ad5.svg";